import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TabStopType, TextRun, VerticalAlign, WidthType } from "docx";


export const overviewHeading = new Paragraph({
    alignment: AlignmentType.LEFT,
    spacing: { before: 150, after: 100, },
    children: [
        new TextRun({
            text: "8.  Overview of Findings",
            size: 22,
            color: "C00000",
            font: "Cambria (Headings)",
            bold: true,
            italics: false,
            allCaps: false
        })
    ],
    heading: HeadingLevel.HEADING_2,
})

export const findingsText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The following table gives of overview of the findings and their status by the end of our security audit process. ",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})